const COMMON_PPREFIX = "store/hintsReducer";

export const SET_PROCESSING = `${COMMON_PPREFIX}/SET_PROCESSING`;
export const FETCH_HINTS = `${COMMON_PPREFIX}/FETCH_FILES`;
export const FETCH_GATES = `${COMMON_PPREFIX}/FETCH_GATES`;
